(() => {
  const { createApp } = Vue;
  
  const appVariantsForm = createApp({
      delimiters: ['${', '}'],
      data() {
        return { 
          CONFIG,
          isLoading: false
        }
      },
  
    computed: {
      addonCategories() {
        return this.CONFIG.addon_categories;
      },
      mainProduct() { 
        return this.CONFIG.product;
      },
      plusAddon() {
        return this.mainProduct.plus_addon || null;
      },
      plusAddonItem() {
        return this.plusAddon ? this.plusAddon.selected_variant : null;
      },
      showPlusToggle() {
        return Boolean(this.plusAddonItem);
      },
      isPlusSelected() {
        return Boolean(this.plusAddonItem && this.plusAddonItem.selected);
      },
      plusAddonQuantity() {
        return this.isDualPack ? 2 : 1;
      },
      plusUpgradePrice() {
        if (!this.showPlusToggle) {
          return 0;
        }

        return (this.plusAddonItem.price || 0) * this.plusAddonQuantity;
      },
      plusToggleLabel() {
        if (!this.showPlusToggle) {
          return '';
        }

        return `Upgrade to Plus - 65 lbs`;
      },
      isDualPack() {
        return this.mainProduct.handle.indexOf('dual') !== -1;
      },
      addons() { 
        const vm = this;
        const sourceCategories = vm.CONFIG.addon_categories;
        const categoryMap = sourceCategories.reduce((map, title, index) => {
          map[title] = vm.CONFIG.addons[index];
          return map;
        }, {});

        const addons = vm.addonCategories.map((title) => {
          const item = categoryMap[title] || { products: [], type: 'single' };
          const products = item.products;
          const type = item.type == 'single' ? 'radio' : 'checkbox';
          
          products.forEach((product) => {
            const nonDefaultVariants = product.variants.filter(v => v.title !== 'Default Title');
            product.hasMultipleVariants = nonDefaultVariants.length > 1;
            product.displayAsParent = product.hasMultipleVariants;
          });
          
          let variants = [];
          products.forEach((product) => {
            variants = [].concat(variants, product.variants);
          });

          variants.forEach((v) => {
            v.product = products.find(p => p.variants.includes(v)) || products[0];
            v.belongsToMultiVariantProduct = v.product && v.product.hasMultipleVariants;
            
            // Set featured image if not already set
            if (!v.featured_image) {
              products.forEach((product) => {
                if (v.name == product.title) {
                  v.featured_image = product.featured_image
                }
              })
            }
          })

          const selectedVariants = variants.filter(v => v.selected);
          let selectedOptions = 'None';
          if (selectedVariants.length) {
            // This is super ugly, eventually this app is gonna get a major facelift but just for time constraint reasons
            const productGroups = {};
            selectedVariants.forEach(v => {
              const productId = v.product ? v.product.id : 'unknown';
              if (!productGroups[productId]) {
                productGroups[productId] = {
                  product: v.product,
                  variants: []
                };
              }
              productGroups[productId].variants.push(v);
            });
            
            selectedOptions = Object.values(productGroups).map(group => {
              const productTitle = group.product ? group.product.title : 'Unknown Product';
              
              if (group.product && group.product.hasMultipleVariants) {
                const variantTitles = group.variants.map(v => {
                  if (v.title.includes("None")) {
                    return v.name.split(" -")[0];
                  }
                  return v.title !== 'Default Title' ? v.title : v.name;
                }).join(', ');
                
                return `${productTitle} - (${variantTitles})`;
              } else {
                return productTitle;
              }
            }).join(', ');
          }
  
          let quantity = 1;
          if (vm.isDualPack) {
            if (title == 'Mounts' || title == 'Plate Dock') {
              quantity = 2;
            }
          }

          return { title, products, variants, selectedVariants, selectedOptions, type, quantity };
        });
        return addons;
      },
      allVariants() {
        let allVariants = [];
        const addonVariants = this.addons ? this.addons.map(addon => addon.variants).flat() : [];
        const mainVariants = this.mainProduct && this.mainProduct.variants ? this.mainProduct.variants : [];
        const plusAddonItems = this.plusAddonItem ? [this.plusAddonItem] : [];
        allVariants = [].concat(mainVariants, addonVariants, plusAddonItems);
  
        return allVariants;
      },
      selectedVariants() {
        return this.allVariants ? this.allVariants.filter(v => v.selected) : [];
      },
      selectedVariantIds() { 
        return this.selectedVariants ? this.selectedVariants.map(v => v.id) : [];
      },
      totalPrice() {
        return this.selectedVariants ? this.selectedVariants.reduce((sum, v) => sum + ((v.quantity || 1) * (v.price || 0)), 0) : 0;
      },
      totalComparePrice() {
        return this.selectedVariants ? this.selectedVariants.reduce((sum, v) => {
          const quantity = v.quantity || 1;
          const comparePrice = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
          return sum + (quantity * (comparePrice || 0));
        }, 0) : 0;
      },
      hasSale() {
        return this.selectedVariants ? this.selectedVariants.some(v => v.compare_at_price && v.compare_at_price > v.price) : false;
      }
    },
  
    watch: {
      totalPrice: {
        handler(newValue, oldValue) {
          const totalPriceElement = document.querySelector('[data-product-price]');
          const totalComparePriceElement = document.querySelector('[data-product-price-compare]');
          const priceWrapper = document.querySelector('[data-price-wrapper]');
          
          if (totalPriceElement) {
            totalPriceElement.textContent = theme.Currency.formatMoney(newValue);
          }
          
          if (this.hasSale && this.totalComparePrice > newValue) {
            if (totalComparePriceElement) {
              totalComparePriceElement.textContent = theme.Currency.formatMoney(this.totalComparePrice);
            }
            if (priceWrapper) {
              priceWrapper.classList.remove('hide');
            }
            if (totalPriceElement) {
              totalPriceElement.classList.add('sale-price');
            }
          } else {
            if (priceWrapper) {
              priceWrapper.classList.add('hide');
            }
            if (totalPriceElement) {
              totalPriceElement.classList.remove('sale-price');
            }
          }
        },
        immediate: true
      },
      addons: {
        handler() {
          this.$nextTick(() => {
            this.recalculateAllAccordionHeights();
          });
        },
        deep: true
      }
    },
    
    beforeMount() {},
  
    mounted() {},
  
    methods: {
      parseTextAsScript(text) {
        const script = document.createElement('script');
        script.text = text;
        document.head.appendChild(script).parentNode.removeChild(script);
      },
      getCartJS() {
        const vm = this;
        return new Promise((resolve) => {
          fetch('/cart?view=rawjs')
          .then(res => res.text())
          .then((res) => {
            vm.parseTextAsScript(res);
            resolve(cart_js);
          });
        });
      },
      
      getVariantImageUrl(variant) {
        if (variant.featured_image && variant.featured_image.src) {
          return variant.featured_image.src;
        }
        if (variant.product && variant.product.featured_image) {
          return variant.product.featured_image;
        }
        
        return null;
      },
  
      getCategoryDisplayTitle(category) { 
        let displayTitle = category;
  
        // TODO: Need better state management for this
        switch (category) {
          case 'Mounts':
            if (this.mainProduct.title.toLowerCase().includes('ancorex')) {
              displayTitle = 'Choose an Additional Mount';
            } else {
              displayTitle = 'Additional Mount (Strap Mount Included)';
            }

            break;
          case 'Attachment':
            if (this.mainProduct.title.toLowerCase().includes('ancorex')) {
              displayTitle = 'ANCORE Attachments';
            }
            else {
              displayTitle = 'Attachments';
            }
            break;
        }
  
        return displayTitle;
      },
  
      getVariantDisplayTitle(variant) {
        if (variant.title.includes("None")) {
          return 'only ' + variant.name.split(" -")[0];
        }
        return (variant.title !== 'Default Title') ? variant.title : variant.name;
      },
      
      formatMoney(value) {
        return theme.Currency.formatMoney(value).replace('.00', '');
      },

      togglePlusUpgrade() {
        if (!this.plusAddonItem) {
          return;
        }

        const item = this.plusAddonItem;
        item.selected = !item.selected;
        item.quantity = item.selected ? this.plusAddonQuantity : 0;
      },

      handlePlusToggleKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.togglePlusUpgrade();
        }
      },

      // ARIA ISSUES
      handleLabelKeydown(e, variant, variants) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();

          const input = e.target.parentNode.querySelector('input[type="radio"], input[type="checkbox"]');
          if (input) {
            const syntheticEvent = {
              target: input,
              currentTarget: e.currentTarget,
              type: 'change'
            };
            this.selectVariant(syntheticEvent, variants, variant);
          }
        }
      },

      handleDualPackKeydown(e, variantIndex, quantity, addon) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          
          const input = e.target.parentNode.querySelector('input[type="radio"]');
          if (input) {
            addon.variants.forEach((v, index) => {
              if (index === variantIndex) {
                v.selected = true;
                v.quantity = quantity;
              } else {
                v.selected = false;
                v.quantity = 0;
              }
            });
            
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      },
  
      selectVariant(e, variantsToDeselect, variant) {
        const type = e.target.type;
        
        // NONE edge case
        if (e.target.value === 'none') {
          const nameMatch = e.target.name.match(/addon_product-(\d+)/);
          if (nameMatch) {
            const categoryIndex = parseInt(nameMatch[1]);
            this.addons[categoryIndex].products.forEach(product => {
              product.selected = false;
              if (product.variants) {
                product.variants.forEach(v => v.selected = false);
              }
            });
          }
          return;
        }
        
        if (type == 'radio') {
          this.selectVariantSingle(e, variantsToDeselect, variant);
        }
        else {
          this.selectVariantMulti(e, variant);
        }
      },
  
      selectVariantSingle(e, variantsToDeselect, variant) {
        const vm = this;
        variantsToDeselect.forEach(v => {
          v.selected = false;
          v.quantity = 0;
        });
        if (variant) {
          variant.selected = true;
          variant.quantity = 1;
          if (variantsToDeselect === this.mainProduct.variants) {
            this.mainProduct.selected_variant = variant;
          }
        }
        if (e.target.dataset.quantity) {
          variant.quantity = e.target.dataset.quantity;
        }

        if (vm.isDualPack && variant.name == 'Carrying Case') {
          variant.quantity = 2;
        }
  
        const target = e.currentTarget;
        const nextStep = target.closest('.variant-selections').dataset.next;
        this.openNextStep(nextStep);
      },
  
      selectVariantMulti(e, variant) {
        const vm = this;
        if (variant) {
          variant.selected = e.target.checked;
          variant.quantity = variant.selected ? 1 : 0;
   
          if (vm.isDualPack && variant.name.includes('Mount')) {
            variant.quantity = 2;
          }
        }
  
        const target = e.currentTarget;
        const nextStep = target.closest('.variant-selections').dataset.next;
        this.openNextStep(nextStep);
      },
  
      addItemsToCart(e) {
        e.preventDefault();
        const vm = this;
        
        vm.isLoading = true;
        
        const items = vm.selectedVariants.map((variant) => {
          return {
            id: variant.id,
            quantity: variant.quantity || 1
          };
        });
  
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        })
          .then(res => res.json())
          .then(vm.refreshCart)
          .finally(() => {
            vm.isLoading = false;
          });
      },
  
      refreshCart(res) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));      
      },
  
      openNextStep(nextStep) { 
        const nextStepElement = document.querySelectorAll('.addon-products-wrap .select-addon-step')[nextStep];
  
        if (nextStepElement) {
          const content = nextStepElement.querySelector('.td-variant-selections');
          if (!nextStepElement.classList.contains('active')) {
            nextStepElement.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        }
      },

      handleDropdownKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleStepView(e);
        }
      },

      handleVariantFocus(e) {
        const step = e.target.closest('.select-addon-step');
        if (step && !step.classList.contains('active')) {
          step.classList.add('active');
          const content = step.querySelector('.td-variant-selections');
          if (content) {
            this.updateAccordionHeight(step, content);
            const dropdownButton = step.querySelector('.addon-category-title');
            if (dropdownButton) {
              dropdownButton.setAttribute('aria-expanded', 'true');
            }
          }
        }
      },
  
      toggleStepView(e) {
        const target = e.currentTarget;
        const step = target.closest('.select-addon-step');

        if (step) {
          const content = step.querySelector('.td-variant-selections');
          const isActive = step.classList.contains('active');
          
          if (isActive) {
            step.classList.remove('active');
            content.style.maxHeight = '0px';
            target.setAttribute('aria-expanded', 'false');
            target.focus();
          }
          else {
            step.classList.add('active');
            this.updateAccordionHeight(step, content);
            target.setAttribute('aria-expanded', 'true');
            
            setTimeout(() => {
              const firstVariant = content.querySelector('label[tabindex="0"]');
              if (firstVariant) {
                firstVariant.focus();
              }
            }, 100); // Small delay to ensure the dropdown is fully opened
          }
        }
      },

      updateAccordionHeight(step, content) {
        content.style.maxHeight = 'none';
        const height = content.scrollHeight;
        content.style.maxHeight = height + 'px';
      },

      recalculateAllAccordionHeights() {
        const activeSteps = document.querySelectorAll('.select-addon-step.active');
        activeSteps.forEach(step => {
          const content = step.querySelector('.td-variant-selections');
          if (content) {
            this.updateAccordionHeight(step, content);
          }
        });
      },
      
      initDOMevents() {},

      getVariantsByProduct(productId, categoryIndex) {
        const addon = this.addons[categoryIndex];
        if (!addon || !addon.products) return [];
        
        const product = addon.products.find(p => p.id === productId);
        return product ? product.variants : [];
      },

      // TODO: this should be handled earlier, I shouldnt have "redo" this
      shouldShowAsParent(variant, categoryIndex) {
        if (!variant.belongsToMultiVariantProduct) return false;
        
        const addon = this.addons[categoryIndex];
        const product = variant.product;
        if (!product || !addon) return false;
        
        const productVariants = this.getVariantsByProduct(product.id, categoryIndex);
        return productVariants.length > 0 && productVariants[0].id === variant.id;
      },

      handleProductSelection(productId, categoryIndex) {
        const addon = this.addons[categoryIndex];
        const product = addon.products.find(p => p.id === productId);
        
        if (!product || !product.hasMultipleVariants) return;
        if (addon.type === 'radio') {
          addon.products.forEach(p => {
            p.selected = false;
            if (p.variants) {
              p.variants.forEach(v => v.selected = false);
            }
          });
        }
        
        product.selected = !product.selected;
        
        if (product.selected) {
          if (product.variants && product.variants.length > 0) {
            const hasSelectedVariants = product.variants.some(v => v.selected);
            if (!hasSelectedVariants) {
              product.variants[0].selected = true;
              product.variants[0].quantity = addon.quantity;
            }
          }
        } else {
          if (product.variants) {
            product.variants.forEach(v => v.selected = false);
          }
        }
      },

      handleVariantSelection(variantId, categoryIndex) {
        const addon = this.addons[categoryIndex];
        let selectedVariant = null;
        let parentProduct = null;
        
        for (const product of addon.products) {
          if (product.variants) {
            const variant = product.variants.find(v => v.id === variantId);
            if (variant) {
              selectedVariant = variant;
              parentProduct = product;
              break;
            }
          }
        }
        
        if (!selectedVariant || !parentProduct) return;
        selectedVariant.selected = !selectedVariant.selected;
        
        if (selectedVariant.selected) {
          selectedVariant.quantity = addon.quantity;
          parentProduct.selected = true;
        } else {
          const hasSelectedVariants = parentProduct.variants.some(v => v.selected);
          if (!hasSelectedVariants) {
            parentProduct.selected = false;
          }
        }
      },
      
      handleDualPackSelection(selectedVariant, productIndex, categoryIndex) {
        const addon = this.addons[categoryIndex];

        addon.products.forEach(product => {
          product.selected = false;
          product.variants.forEach(variant => {
            variant.selected = false;
            variant.quantity = 0;
          });
        });
        
        selectedVariant.selected = true;
        selectedVariant.quantity = selectedVariant.quantity || 1;
        addon.products[productIndex].selected = true;
      }
    }
  }).mount('#product-form-addon');
})();
